export const ServiceCode = {
    SUCCESS: 200,
    FAIL: 501,
    ERROR: 505
};